import React, {PropsWithChildren, useContext} from 'react';

import {ServerDataContext} from './ServerDataContext';


export interface CardFeeRecoveryContextValue {
    isEnabled: boolean;
    isShowDiscountPercentageOnInvoice: boolean;
    feePercent: number;
}

export const CARD_FEE_RECOVERY_CONTEXT_VALUE_DEFAULT: CardFeeRecoveryContextValue = {
    isEnabled: false,
    isShowDiscountPercentageOnInvoice: false,
    feePercent: 0,
}

export const CardFeeRecoveryContext = React.createContext<CardFeeRecoveryContextValue>(CARD_FEE_RECOVERY_CONTEXT_VALUE_DEFAULT);

export const CardFeeRecoveryProvider: React.FunctionComponent<PropsWithChildren> = ({children}) => {
    const data = useContext(ServerDataContext);

    const value: CardFeeRecoveryContextValue = data.cardFeeRecovery
        ? {
            isEnabled: data.cardFeeRecovery.is_enabled,
            isShowDiscountPercentageOnInvoice: data.cardFeeRecovery.is_show_discount_percentage_on_invoice,
            feePercent: data.cardFeeRecovery.fee_percent,
        }
        : CARD_FEE_RECOVERY_CONTEXT_VALUE_DEFAULT

    return (
        <CardFeeRecoveryContext.Provider value={value}>
            {children}
        </CardFeeRecoveryContext.Provider>
    );
};

export const useCardFeeRecoveryContext = (): CardFeeRecoveryContextValue => {
    return useContext(CardFeeRecoveryContext);
}